



































































import { Component, Prop, Vue } from 'vue-property-decorator'

import util from '@/utils/tools'
import compConfig from '@/config/componentConfig'
import upload from '@/components/upload.vue'

@Component({
  name: 'GoodsItem',
  components: {
    upload
  }
})
export default class GoodsItem extends Vue {
  @Prop({ default: null })
  private items?: Array<any>

  private defaultConf:any = util.copyObj(compConfig['goods'])
  private list: Array<any> = this.items || []

  private upItem (idx: number): void {
    const tmp: any = util.copyObj(this.list[idx])
    this.list.splice(idx, 1)
    this.list.splice(idx - 1, 0, tmp)
  }

  private downItem (idx: number): void {
    const tmp: any = util.copyObj(this.list[idx])
    this.list.splice(idx, 1)
    this.list.splice(idx + 1, 0, tmp)
  }

  private delItem (idx: number): void {
    this.list.splice(idx, 1)
  }

  private addItem (): void {
    if (this.list.length < 20) {
      this.list.push(util.copyObj(this.defaultConf.action.config[0]))
    } else {
      this.$alert('最多添加20个列表项！')
    }
  }
}
